<hlm-popover align="start" [state]="overlayState()" (stateChanged)="onStateChanged($event)">
  <!-- Trigger: input-like container -->
  <button
    #trigger
    type="button"
    hlmPopoverTrigger
    class="member-multiselect-input__trigger"
    [class.member-multiselect-input__trigger--active]="isActive()"
    [attr.aria-label]="ariaLabel()"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isActive()"
    (click)="onTriggerClick()"
    (keydown.space)="$event.preventDefault()"
  >
    @if (selectedOptions().length === 0) {
      <span class="member-multiselect-input__placeholder">
        {{ placeholder() }}
      </span>
    } @else {
      @for (option of selectedOptions(); track trackByValue($index, option)) {
        <span
          class="member-multiselect-input__chip"
          [class.member-multiselect-input__chip--active]="isActive()"
        >
          <ocp-avatar
            [userInitials]="option.initials"
            [colorSeed]="option.email"
            size="md"
            fontWeight="bold"
            class="member-multiselect-input__chip-avatar"
          />
          <span class="member-multiselect-input__chip-label">{{
            truncateLabel(option.label)
          }}</span>
          <button
            type="button"
            class="member-multiselect-input__chip-remove"
            [attr.aria-label]="'Remove ' + option.label"
            (click)="$event.stopPropagation(); removeChip(option, $event)"
            (keydown.enter)="removeChip(option, $event)"
            (keydown.space)="$event.preventDefault(); removeChip(option, $event)"
          >
            <ocp-themed-icon name="cross.svg" [size]="9" />
          </button>
        </span>
      }
    }
  </button>

  <!-- Dropdown popover -->
  <hlm-popover-content
    *hlmPopoverPortal
    [style.width]="triggerWidth()"
    [style.max-height]="'calc(100dvh - 2rem)'"
    style="overflow: hidden"
  >
    <ocp-member-select-panel
      #panel
      [options]="options()"
      [selectedIds]="selectedIds()"
      (memberToggled)="onMemberToggled($event)"
      (closeRequested)="closePopover()"
    />
  </hlm-popover-content>
</hlm-popover>
